import React from 'react';
import { createRoot } from 'react-dom/client';

import addAmChartsLicense from './components/Charts/utils/addLicense';

import App from './App';
import { unregister } from './registerServiceWorker';
import { shouldRenderPreview } from './previewEntry';

const container = document.getElementById('root');
const root = createRoot(container);

if (!container) {
  throw new Error('no container element found');
}

addAmChartsLicense();

// Dev-only preview: render the revamped Performance screen standalone — bypasses
// Apollo, auth, and data-loading providers. Visit `/?preview=performance`.
// Gated on `import.meta.env.DEV` so a Vite production build statically drops this
// branch and tree-shakes the preview module (and its mock data) out of the bundle.
if (shouldRenderPreview(window.location.search, import.meta.env.DEV)) {
  import('./PerformanceRevampedPreview').then(({ default: PerformanceRevampedPreview }) => {
    root.render(<PerformanceRevampedPreview />);
  });
} else {
  root.render(<App />);
}
unregister();
